/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { TestAiCredentialMutationResponse, TestAiCredentialPathParams, TestAiCredential400, TestAiCredential401, TestAiCredential403, TestAiCredential404, TestAiCredential409, TestAiCredential500 } from "../../types/platformBillingController/TestAiCredential.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { testAiCredential } from "../../client/platformBillingController/testAiCredential.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const testAiCredentialMutationKey = () => [{ url: '/api/organizations/:organizationId/platform-billing/credentials/:provider/test' }] as const

export type TestAiCredentialMutationKey = ReturnType<typeof testAiCredentialMutationKey>

export function testAiCredentialMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = testAiCredentialMutationKey()
        return mutationOptions<TestAiCredentialMutationResponse, ResponseErrorConfig<TestAiCredential400 | TestAiCredential401 | TestAiCredential403 | TestAiCredential404 | TestAiCredential409 | TestAiCredential500>, {organizationId: TestAiCredentialPathParams["organizationId"], provider: TestAiCredentialPathParams["provider"]}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, provider }) => {
            return testAiCredential(organizationId, provider, config)
          },
        })

}

/**
 * @summary Test a stored BYOK provider key (boolean-only)
 * {@link /api/organizations/:organizationId/platform-billing/credentials/:provider/test}
 */
export function useTestAiCredential<TContext>(options: 
{
  mutation?: UseMutationOptions<TestAiCredentialMutationResponse, ResponseErrorConfig<TestAiCredential400 | TestAiCredential401 | TestAiCredential403 | TestAiCredential404 | TestAiCredential409 | TestAiCredential500>, {organizationId: TestAiCredentialPathParams["organizationId"], provider: TestAiCredentialPathParams["provider"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? testAiCredentialMutationKey()

          const baseOptions = testAiCredentialMutationOptions(config) as UseMutationOptions<TestAiCredentialMutationResponse, ResponseErrorConfig<TestAiCredential400 | TestAiCredential401 | TestAiCredential403 | TestAiCredential404 | TestAiCredential409 | TestAiCredential500>, {organizationId: TestAiCredentialPathParams["organizationId"], provider: TestAiCredentialPathParams["provider"]}, TContext>
          

          return useMutation<TestAiCredentialMutationResponse, ResponseErrorConfig<TestAiCredential400 | TestAiCredential401 | TestAiCredential403 | TestAiCredential404 | TestAiCredential409 | TestAiCredential500>, {organizationId: TestAiCredentialPathParams["organizationId"], provider: TestAiCredentialPathParams["provider"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<TestAiCredentialMutationResponse, ResponseErrorConfig<TestAiCredential400 | TestAiCredential401 | TestAiCredential403 | TestAiCredential404 | TestAiCredential409 | TestAiCredential500>, {organizationId: TestAiCredentialPathParams["organizationId"], provider: TestAiCredentialPathParams["provider"]}, TContext>
      
}